import React, { useState } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import config from '../config/index.json';
import { useNavigate } from 'react-router-dom';

function LatestNews() {

    const navigate = useNavigate();

    const CONTENTFUL_SPACE_ID = "qitjy5hyl5up"
    const CONTENTFUL_ACCESS_TOKEN = "TKo1zCQL_v1NQmGcRQXQVqayvDSqukrdCeRlbpEedyM"  
    const contentfulEndpointNews = `https://cdn.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/environments/master/entries?access_token=${CONTENTFUL_ACCESS_TOKEN}&content_type=news`;
  
    const { images } = config;
    const { arrow } = images;

    const [ totalNews, setTotalNews ] = useState<any>()
    const [ newsItems, setNewsItems ] = useState<any[]>()
    const [ isHovered, setIsHovered ] = useState(false)
    const [ hoveredIndex, setHoveredIndex ] = useState(-1)

    useEffect(() => {
        AOS.init({ duration: 2000 });
        (async () => {
            try {
              const res = await fetch(contentfulEndpointNews);
              const data = await res.json();
              setTotalNews(data)
              setNewsItems(data.items.sort(function(item_a:any, item_b:any){return item_b.fields.date.localeCompare(item_a.fields.date)}));
              console.log('newsdata', data)
              console.log('items', newsItems)
            } catch (error) {
              console.log(error);
            }
          })();
    }, []);

    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const handleClick = (index: number) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const handleSelectNews = (nid:string) => {
        console.log('nid',nid)
        navigate('/news', {state: {nid:nid}})
      }

    return (
        <section id='news' className='bg-darkblue relative'>
            <h3 className='text-white text-3xl p-8 absolute z-10'> Ultime notizie</h3>
            <div className='grid grid-cols-3 md:flex-row items-center lastNews'>
                <div
                    onMouseEnter={()=>{setIsHovered(true); setHoveredIndex(0);}} 
                    onMouseLeave={()=>setIsHovered(false)}
                    onClick={()=>handleSelectNews(newsItems ? newsItems[0].sys.id : '')}
                    data-aos="fade-down"
                    className="place-items-end cursor-pointer  bg-cover bg-black w-full item flex h-full relative">
                    <div 
                        style={{
                        zIndex: 1,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: `rgba(0, 0, 0, ${isHovered && hoveredIndex==0 ? '0.5': '0'})`, /* Adjust the alpha value to change the darkness */
                        pointerEvents: 'none', /* Allows mouse events to 'fall through' the overlay to the anchor tag */
                        }}
                    > 
                    </div>
                    <span className={`block h-auto absolute bottom-12 px-12 z-10 `}>
                        <div>
                            <span className='font-300 text-white'>{newsItems ? newsItems[0].fields.date : ''}</span><br />
                            <span className='text-white text-4xl leading-snug font-semibold pr-8'>{newsItems && newsItems[0]?.fields.title}</span>
                        </div>
                        <img src={arrow} className={`w-6 ${(isHovered && 0==hoveredIndex) ? 'mt-16 ms-4':'mt-10'} mb-4`} />
                    </span>
                    <img src={totalNews?.includes.Asset.filter((asset:any)=>{if(newsItems && newsItems?.length>0) {return asset.sys.id==newsItems[0].fields.coverImage.sys.id} else return 1})[0].fields.file.url} className="absolute mb-0  thumb-news-slide w-full h-full object-cover max-w-none" />
                </div>
                <div
                    onMouseEnter={()=>{setIsHovered(true); setHoveredIndex(1);}} 
                    onMouseLeave={()=>setIsHovered(false)}
                    onClick={()=>handleSelectNews(newsItems ? newsItems[0].sys.id : '')}
                    data-aos="fade-down" data-aos-offset="250"
                    className="cursor-pointer place-items-end bg-black w-full item flex h-full relative">
                    <div 
                        style={{
                        zIndex: 1,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: `rgba(0, 0, 0, ${isHovered && hoveredIndex==1 ? '0.5': '0'})`, /* Adjust the alpha value to change the darkness */
                        pointerEvents: 'none', /* Allows mouse events to 'fall through' the overlay to the anchor tag */
                        }}
                    > 
                    </div>
                    <span className={`block h-auto absolute bottom-12 px-12 z-10`}>
                        <div>
                            <span className='font-300 text-white'>{newsItems ? newsItems[1].fields.date : ''}</span><br />
                            <span className='text-white text-4xl leading-snug font-semibold pr-8'>{newsItems ? newsItems[1].fields.title : ''}</span>
                        </div>
                        <img src={arrow} className={`w-6 ${(isHovered && 1==hoveredIndex) ? 'mt-16 ms-4':'mt-10'} mb-4`} />
                    </span>
                    <img src={totalNews?.includes.Asset.filter((asset:any)=>{if(newsItems && newsItems?.length>0) {return asset.sys.id==newsItems[1].fields.coverImage.sys.id} else return 1})[0].fields.file.url} className='thumb-news-slide mb-0 w-full h-full object-cover max-w-none absolute' />
                </div>
                <div
                    onMouseEnter={()=>{setIsHovered(true); setHoveredIndex(2);}} 
                    onMouseLeave={()=>setIsHovered(false)}
                    onClick={()=>handleSelectNews(newsItems ? newsItems[0].sys.id : '')}
                    data-aos="fade-down" data-aos-offset="500"
                    className="cursor-pointer place-items-end bg-black w-full item flex relative h-full">
                    <div 
                        style={{
                        zIndex: 1,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: `rgba(0, 0, 0, ${isHovered && hoveredIndex==2 ? '0.5': '0'})`, /* Adjust the alpha value to change the darkness */
                        pointerEvents: 'none', /* Allows mouse events to 'fall through' the overlay to the anchor tag */
                        }}
                    > 
                    </div>    
                        <span className={`block h-auto absolute bottom-12 px-12 z-10`}>
                            <div>
                                <span className='font-300 text-white'>{newsItems ? newsItems[2].fields.date : ''}</span><br />
                                <span className='text-white text-4xl leading-snug font-semibold'>{newsItems ? newsItems[2].fields.title : ''}</span>
                            </div>
                            <img src={arrow} className={`w-6 ${(isHovered && 2==hoveredIndex) ? 'mt-16 ms-4':'mt-10'} mb-4`} />
                        </span>
                        <img src={totalNews?.includes.Asset.filter((asset:any)=>{if(newsItems && newsItems?.length>0) {return asset.sys.id==newsItems[2].fields.coverImage.sys.id} else return 1})[0].fields.file.url} className='thumb-news-slide mb-0 w-full h-full object-cover max-w-none absolute' />
                </div>
            </div>
        </section>
    )
}

export default LatestNews